export default __webpack_public_path__ + "static/media/sportbild.298c53e9.png";